<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="hero-basic">
    <div class="hero-basic-inner wrapper">
      <h1 class="hero-basic__title" v-html="content.title"></h1>
      <GPicture
        v-if="content.picture"
        :content="content.picture"
        class="hero-basic__picture cover"
        :default-sizes="defaultImageSize"
      />
    </div>
  </div>
</template>

<script lang="ts">
import type { Picture } from '@/types'

export interface HeroBasic {
  title: string
  picture: Picture
}
</script>

<script setup lang="ts">
import { useHead } from '@vueuse/head'

import { parseSets } from '@/modules/utils'

import type { PropType } from 'vue'

const props = defineProps({
  content: {
    type: Object as PropType<HeroBasic>,
    required: true,
  },
})

const defaultImageSize = '100vw'

useHead({
  link: [
    {
      rel: 'preload',
      as: 'image',
      href: props.content?.picture?.src,
      imagesrcset:
        props.content?.picture?.sets && parseSets(props.content.picture.sets),
      imagesizes: defaultImageSize,
    },
  ],
})
</script>

<style lang="scss" scoped>
.hero-basic {
  // prettier-ignore
  @include fluid(height, (xxs: 34rem, xxl: 54rem));

  position: relative;
  background-color: $c-dev-bg;
}

.hero-basic-inner {
  height: 100%;
}

.hero-basic__title {
  @include center-xy;

  position: relative;
  z-index: 1;
  margin: 0;
  padding-top: $header-height-mobile;
  color: $c-white;
  text-align: center;

  @include mq(l) {
    padding-top: $header-height;
  }
}

.hero-basic__picture {
  @include get-all-space;

  &::after {
    @include get-all-space;

    content: '';
    background: linear-gradient(
      0deg,
      rgba(0, 0, 0, 30%) 0%,
      rgba(0, 0, 0, 30%) 100%
    );
  }
}
</style>
